/**
 * Endpoints du domaine shared (transverse) — source canonique.
 * `@/core/api/endpoints` ré-exporte ces valeurs : ajouter les routes ICI.
 */
export const sharedEndpoints = {} as const;
